import { NgModule } from '@angular/core';
import { formatMoneyDiscountPipe, formatMoneyPipe, moblieOtpPipe, sanitizeHtmlPipe } from './sanitize-html.pipe';
const IMPORT_PIPE = [
  sanitizeHtmlPipe,
  moblieOtpPipe,
  formatMoneyPipe,
  formatMoneyDiscountPipe,
]

@NgModule({
  declarations: [...IMPORT_PIPE],
  imports: [],
  exports: [...IMPORT_PIPE]
})
export class PipesModule { }